import EditVendorCertificationContainer from "./EditVendorCertificationContainer";
export default EditVendorCertificationContainer;
